(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post-tas"]) return;
  try {
    
(function () {
  var tocList = document.getElementById('bpt-toc-list');
  if (!tocList) return;

  var headings = document.querySelectorAll('.bpt-content h2');
  if (!headings.length) { document.getElementById('bpt-toc')?.remove(); return; }

  headings.forEach(function (h, i) {
    if (!h.id) h.id = 'bpt-h-' + i;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    li.appendChild(a);
    tocList.appendChild(li);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orenda-astro-analysis"] && !Shopify.designMode) return;
  try {
    
  if (!window.orendaAnalysisBridgeReady) {
    window.orendaAnalysisBridgeReady = true;
    window.addEventListener('message', (event) => {
      if (!event.data || event.data.type !== 'orenda-analysis-height') return;
      const frame = Array.from(document.querySelectorAll('.orenda-analysis-frame')).find(
        (candidate) => candidate.contentWindow === event.source
      );
      if (!frame) return;
      const allowedOrigin = new URL(frame.src).origin;
      if (event.origin !== allowedOrigin) return;
      const requestedHeight = Number(event.data.height);
      if (!Number.isFinite(requestedHeight)) return;
      frame.style.height = `${Math.min(Math.max(requestedHeight, 760), 24000)}px`;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
